import { ComponentProps } from 'lib/component-props';
import ArticlesSectionComponent from 'components/Sections/RelatedArticlesVariations/ArticlesSectionComponent';
import React from 'react';
import { useI18n } from 'next-localization';
import { GetStaticComponentProps, useComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';
import { defaultLanguage } from 'temp/config';
import { pressReleaseService } from 'lib/services/PressReleaseService';
import { PressReleaseData } from 'model/PressReleases';
import styles from '../Tiles/PressReleaseCard.module.scss';
import { PressReleaseCardAdapter } from 'components/Tiles/PressReleaseCardAdapter';

type LatestPressReleaseData = {
  article_publication_date: string;
  article_url: string;
  article_description: string;
  article_title: string;
  article_type: string;
  article_duration: number;
};

const LatestPressReleasesSection = ({ rendering, fields }: ComponentProps) => {
  const { t } = useI18n();
  const pressReleases = useComponentProps(rendering.uid) as PressReleaseData[];

  if (!pressReleases?.length) return null;

  const mappedData: Array<LatestPressReleaseData> = pressReleases.map((item) => ({
    ...item,
    article_publication_date: item.pressReleasePublicationDate.formattedDateValue,
    article_url: `${fields.baseUrl.value}/${item.name?.toLowerCase().replaceAll(' ', '-')}`,
    article_duration: item.duration.value,
    article_strapline: item.pressReleaseDescription.value,
    article_title: item.pressReleaseTitle.value,
    article_type: item.template.id,
  }));

  return (
    <div className={styles['latest-press-release']}>
      <ArticlesSectionComponent
        rendering={rendering}
        articles={mappedData}
        sectionTitle={t('latestPressReleasesTitle')}
        sliderCardComponent={PressReleaseCardAdapter}
      />
    </div>
  );
};

export const getStaticProps: GetStaticComponentProps = async (_rendering, layoutData) => {
  const siteId = layoutData.sitecore.context?.siteRoot;
  const language = layoutData.sitecore.context.language ?? defaultLanguage;

  return await pressReleaseService.getLatestPressReleases(language, siteId);
};

export default LatestPressReleasesSection;
